import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import InputField from "@metacrm/metacrm-material-ui/dist/InputField";
import { useIntl } from "react-intl";
import SettingItem from "features/metadesk/settings/Customization/SettingSupportCenter/SettingItem/SettingItem";
import { StyledFormTitle } from "features/metadesk/settings/integrations/IntegrationWidgetSetting.styles";
import OptInDemoTemplate from "./OptInDemoTemplate";

const CustomizeOptIn = ({
  handleChange,
  configs,
  colorArray,
  handleColorChange,
}) => {
  const { formatMessage } = useIntl();
  const { title, subtitle } = configs;

  return (
    <>
      {/* Title */}
      <StyledFormTitle center item xs={12} md={4}>
        {formatMessage({
          id: "global.column.title",
        })}
      </StyledFormTitle>
      <Grid position={"relative"} item xs={12} md={8}>
        <InputField
          placeholder={formatMessage({
            id: "global.column.title.placeholder",
          })}
          onChange={(event) => {
            handleChange({
              event,
            });
          }}
          maxLength={50}
          name={`title`}
          value={title}
        />
      </Grid>

      {/* Subtitle */}
      <StyledFormTitle center item xs={12} md={4}>
        {formatMessage({
          id: "global.column.subtitle",
        })}
      </StyledFormTitle>
      <Grid position={"relative"} item xs={12} md={8}>
        <InputField
          placeholder={formatMessage({
            id: "global.column.subtitle.placeholder",
          })}
          onChange={(event) => {
            handleChange({
              event,
            });
          }}
          maxLength={250}
          multiline={true}
          name={`subtitle`}
          value={subtitle}
        />
      </Grid>

      {/* Color Setting */}
      <StyledFormTitle center item xs={12} md={4}>
        {formatMessage({
          id: "notification.subscribeBtn.customizeColor",
        })}
      </StyledFormTitle>
      <Grid position={"relative"} item xs={12} md={8}>
        {colorArray.map((colorSetting, index) => (
          <React.Fragment key={colorSetting.name}>
            <SettingItem
              index={index + 1}
              colorSetting={colorSetting}
              onChange={handleColorChange}
              hideTitle
            />
            {index !== colorArray.length - 1 && <div className="mhr"></div>}
          </React.Fragment>
        ))}
      </Grid>

      {/* Preview */}
      <StyledFormTitle item xs={12} md={4} mt="24px" color="#A5A5A5">
        {formatMessage({
          id: "profileSetting.companyProfile.preview",
        })}
      </StyledFormTitle>
      <Grid position={"relative"} item xs={12} md={8} mt="24px">
        <Box
          sx={{
            padding: "75px 0",
            background: "#E6E6E6",
            position: "relative",
            borderRadius: "14px",
          }}
        >
          <OptInDemoTemplate
            customizedTitle={title}
            customizedSubtitle={subtitle}
            colorArray={colorArray}
          />
        </Box>
      </Grid>
    </>
  );
};

export default CustomizeOptIn;
